import CategoryView from "@/components/feature/CategoryView";

export default function DramaCategoryPage() {
  return (
    <CategoryView
      config={{
        type: "drama",
        crumb: "伦理电视剧",
        title: "伦理电视剧",
        description:
          "聚焦连续性剧集形式的韩国伦理题材电视剧，多以群像与长线叙事展开。你可以按类型、年份与集数区间筛选，挑选适合长时间追看的作品。",
        meta: {
          title: "韩国伦理 - 伦理电视剧专题，经典韩国伦理电视剧推荐",
          description:
            "韩国伦理电视剧专题页，收录最新与经典伦理题材韩剧，提供剧情介绍、集数信息、评分与影评，支持按类型、年份、集数筛选浏览。",
          keywords: "韩国伦理电视剧,伦理韩剧,韩国伦理剧推荐,伦理电视剧专题,韩剧剧情",
        },
      }}
    />
  );
}